import { enqueueSnackbar } from '@common/components/SnackBar';

export function getApiErrorMessages(err: any): string[] {
	const error = err?.response?.data ?? err;

	if (typeof error?.errors === 'string') {
		return [error.errors];
	}

	if (error?.errors && typeof error.errors === 'object') {
		const messages = Object.values(error.errors).flatMap((message) =>
			Array.isArray(message) ? message : [message],
		);
		const stringMessages = messages.filter((message): message is string => typeof message === 'string');

		if (stringMessages.length) {
			return stringMessages;
		}
	}

	if (typeof error?.message === 'string') {
		return [error.message];
	}

	return [];
}

function handleApiErrors(err: any) {
	const messages = getApiErrorMessages(err);

	if (messages.length) {
		messages.forEach((message) => enqueueSnackbar(message, { variant: 'error' }));
		return;
	}

	enqueueSnackbar('Unexpected error occurred', { variant: 'error' });
}

export default handleApiErrors;
